import React, { useEffect } from 'react';
import { useData } from '../contexts/DataContext';

const ResizeListener: React.FC = () => {
  const { state, dispatch } = useData();
  
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const isMobile = window.innerWidth < 768;
        // Only dispatch if the state has actually changed
        if (state.isMobile !== isMobile) {
          dispatch({ type: 'SET_ISMOBILE', payload: isMobile });
        }
      }, 150); // Adjust the debounce time as needed
    };

    // Initialize on component mount
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Remove event listener on component unmount
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', handleResize);
    };
  }, [state.isMobile, dispatch]);

  return null; // This component doesn't render anything
};

export default ResizeListener;
